module.exports = __webpack_public_path__ + "static/media/icon_orders.46b53c45.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon_orders.svg
// module id = 774
// module chunks = 0